var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["iframeResizer"]: () => (__WEBPACK_EXTERNAL_MODULE_iframe_resizer_1512d797__.iframeResizer) });